module.exports = __webpack_public_path__ + "img/largeScreenTitle2.823e54dc.png";